module.exports = __webpack_public_path__ + "static/3-6d8704889c6fee7cc0383130984e9994.png";